// extracted by css-extract-rspack-plugin
export default {"ContributorFooterContainer":"ContributorFooter-module__ContributorFooterContainer__rrkBJ"};